var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsEmail, IsEnum, IsInt, IsNotEmpty, IsString, IsUrl, ValidateNested } from "class-validator";
import { PartnerScope } from "../../model.types";
import { safeAssign } from "./safe-assign";
export class APIClientAccessDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], APIClientAccessDTO.prototype, "companyId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], APIClientAccessDTO.prototype, "companyName", void 0);
export class APIClientDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], APIClientDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], APIClientDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], APIClientDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], APIClientDTO.prototype, "website", void 0);
__decorate([
    Expose(),
    IsEnum(PartnerScope, { each: true }),
    __metadata("design:type", Array)
], APIClientDTO.prototype, "partnerScopes", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => APIClientAccessDTO),
    __metadata("design:type", Array)
], APIClientDTO.prototype, "accesses", void 0);
export function toAPIClientDTO({ id, name, email, website, partnerScopes }, accesses) {
    return new APIClientDTO({ id, name, email, website, partnerScopes, accesses });
}
/** The secret is returned exactly once, on creation. */
export class CreatedAPIClientDTO extends APIClientDTO {
    constructor(props) {
        super(props);
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CreatedAPIClientDTO.prototype, "secret", void 0);
export class UpdateAPIClientAccessDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateAPIClientAccessDTO.prototype, "clientId", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], UpdateAPIClientAccessDTO.prototype, "companyId", void 0);
export class CreateAPIClientDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateAPIClientDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsEmail(),
    __metadata("design:type", String)
], CreateAPIClientDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    IsUrl(),
    __metadata("design:type", String)
], CreateAPIClientDTO.prototype, "website", void 0);
//# sourceMappingURL=api-client.dto.js.map